<script setup lang="ts">
import "./MIcon.scss";
import { computed } from "vue";
import type { MIconProps } from "./MIcon.props";

const props = defineProps<MIconProps>();

const QUASAR_SIZE_KEYWORDS = new Set(["xs", "sm", "md", "lg", "xl"]);

const iconClasses = computed(() => {
  const classes: (string | false)[] = ["m-icon", props.name];
  if (props.size && QUASAR_SIZE_KEYWORDS.has(props.size)) {
    classes.push(`m-icon--size-${props.size}`);
  }
  return classes;
});

const iconStyles = computed(() => {
  const styles: Record<string, string> = {};
  if (props.size && !QUASAR_SIZE_KEYWORDS.has(props.size)) {
    styles["font-size"] = props.size;
  }
  if (props.color) {
    styles.color = props.color;
  }
  return styles;
});
</script>

<template>
  <i :class="iconClasses" :style="iconStyles" aria-hidden="true">
    <slot />
  </i>
</template>
